import { IMacaronTemplate } from "design-system/src/Core/ProductBlock/MacaronBadge/MacronBadge.interface";

export interface IDiscountProductOffered {
  id_discount: string;
  value: string;
  available_from: string;
  available_to: string;
  order_total_minimum: number;
  all_catalogue: string;
  only_app: boolean;
  targets?: {
    product: string[];
    category: string[];
  };
  triggers?: {
    product: string[];
    category: string[];
  };
  name: string;
  id_product: string;
  is_web: boolean;
  reference_caisse: string;
  active: boolean;
  display_value: string;
  display_minimum: string;
  display_message: string;
}

export enum EStoreExclusion {
  NONE = 0, // Pas de limitation
  ONLY_SELECTED = 1, // Limiter aux boutiques sélectionnées
  EXCLUDE_SELECTED = 2, // Exclure les boutiques sélectionnées
}

export enum CarrierType {
  NOW_CLICK_AND_COLLECT = "1",
  NOW_DELIVERY = "2",
  DIFFERED_CLICK_AND_COLLECT = "3",
  DIFFERED_DELIVERY = "4",
}

export type IDiscountKxm = {
  id_discount: string;
  conditions_text?: string;
  macaron_name: string;
  macaron_template: IMacaronTemplate;
  macaron_color: string;
  macaron_text_color: string;
  value: string;
  available_from: string;
  available_to: string;
  visibility: {
    active: boolean;
    day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    deb: string;
    end: string;
  }[];
  order_total_minimum: string;
  valueReduce: string;
  n_by: string;
  m_reduct: string;
  all_catalogue: string;
  only_app: boolean;
  trigger_products_id: string[];
  target_products_id: string[];
  is_bogo?: boolean;
  is_web?: boolean;
  is_trigger_eq_target?: boolean;
  customer_groups?: string[];
  stores?: string[];
  stores_exclusion?: EStoreExclusion;
  id_carriers?: CarrierType[];
};

export type IDiscountNudgeVAEVisibility = {
  active: boolean;
  day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  deb: string;
  end: string;
};

export type IDiscountNudgeVAE = {
  name: string;
  id_discount: string;
  nudge_vae_message: string;
  available_from: string;
  available_to: string;
  customer_groups?: string[];
  stores?: string[];
  stores_exclusion?: EStoreExclusion;
  generate_page?: boolean;
  visibility?: IDiscountNudgeVAEVisibility[];
};
